import { render, staticRenderFns } from "./RzoPowerStatsDetails.vue?vue&type=template&id=61fbe036&"
import script from "./RzoPowerStatsDetails.vue?vue&type=script&lang=js&"
export * from "./RzoPowerStatsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./RzoPowerStatsDetails.vue?vue&type=custom&index=0&blockType=i18n&scoped=true"
if (typeof block0 === 'function') block0(component)

export default component.exports